import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const PageViews = () => {
  const { pathname, search } = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const frame = requestAnimationFrame(() => {
      window.gtag?.("event", "page_view", {
        page_title: document.title,
        page_location: window.location.href,
      });
    });

    return () => cancelAnimationFrame(frame);
  }, [pathname, search]);

  return null;
};
